import { render, staticRenderFns } from "./Pocetna.vue?vue&type=template&id=2bc9ac1a&scoped=true&"
import script from "./Pocetna.vue?vue&type=script&lang=js&"
export * from "./Pocetna.vue?vue&type=script&lang=js&"
import style0 from "./Pocetna.vue?vue&type=style&index=0&id=2bc9ac1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc9ac1a",
  null
  
)

export default component.exports